// CRM API - barrel re-export combining all CRM sub-modules
import { crmPipelineApi } from "./pipeline";
import { crmLeadsApi } from "./leads";
import { crmDocumentsApi } from "./documents";
import { crmRemindersApi } from "./reminders";
import { crmSettingsApi } from "./settings";
import { crmMessagesApi } from "./messages";

export type {
	PipelineStage,
	LeadSource,
	Lead,
	LeadActivity,
	LeadDocument,
	LeadReminder,
	CrmSettings,
	KanbanLead,
	KanbanData,
	CrmDashboard,
	ReminderCounts,
	CreateLeadInput,
	UpdateLeadInput,
	AddNoteInput,
	ChangeStageInput,
	Message,
	TimelineEntry,
	LeadMessagesData,
} from "./types";

export const crmApi = {
	...crmPipelineApi,
	...crmLeadsApi,
	...crmDocumentsApi,
	...crmRemindersApi,
	...crmSettingsApi,
	...crmMessagesApi,
};
